export default {
    x: 100,
    y: 300,
    percentage: 1
};